/**
 * Растянута ли обложка на всю ширину экрана.
 *
 * Главная спрашивает об этом, чтобы решить, ГДЕ отрисовать обложку: внутри
 * колонки контента (как всегда) или до контейнера, отдельным блоком во всю ширину.
 * Одним CSS обойтись нельзя — колонка контента обрезает всё, что вылезает за её
 * границы (`.grid-container__content { overflow: hidden }`), так что вытащить
 * обложку наружу отрицательными отступами не выйдет.
 *
 * Условие живёт здесь, а не в шаблоне страницы: рядом с ним уже стоит
 * `coverRendersHeading`, и оба ответа про обложку должны читаться в одном месте.
 */
import { coverStretchesFullBleed, type AppearanceConfig, type AppearanceSurfaceKey } from '@shared/config'

export function coverIsFullBleed(
  appearance: AppearanceConfig,
  surface: AppearanceSurfaceKey,
): boolean {
  // Обложка — настройка сайта: в нативной сборке её нет вовсе (см. SiteCover.vue)
  if (surface !== 'site') return false

  // Само условие — в @shared/config: его же спрашивает шапка, чтобы стать прозрачной
  return coverStretchesFullBleed(appearance?.cover)
}
